import { GETDASHBOARD_SUCCESS } from '../types';

const initialState = {
  dashboardData: null,
  dashboardBalance: null
};

export default function DashboardReducer(state = initialState, action) {
  switch (action.type) {
    case GETDASHBOARD_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload
      };
    default:
      return state;
  }
}
